import { useEffect, useRef, useState } from "react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useVault } from "@/context/VaultContext";
import { Header } from "./Header";
import { StarLogo } from "./StarLogo";
import { FolderNav } from "./FolderNav";
import FolderView from "./FolderView";
import CalendarView from "./CalendarView";
import NoteEditor from "./NoteEditor";
import ProfileStudio from "./ProfileStudio";
import MergeDialog from "./MergeDialog";
import BackupDialog from "./BackupDialog";
import AboutDialog from "./AboutDialog";

export default function MainLayout() {
  const { noteId, dialog, setDialog, view } = useVault();
  const [nav, setNav] = useState(false);
  const searchRef = useRef(null);
  const close = (o) => !o && setDialog(null);
  useEffect(() => {
    const onKey = (e) => {
      const typing = /INPUT|TEXTAREA|SELECT/.test(e.target.tagName) || e.target.isContentEditable;
      if ((e.key === "k" && (e.metaKey || e.ctrlKey)) || (e.key === "/" && !typing)) { e.preventDefault(); searchRef.current?.focus(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <div className="min-h-screen w-full max-w-[100vw] overflow-x-clip flex flex-col bg-background" data-testid="main-layout">
      <Header onMenu={() => setNav(true)} searchRef={searchRef} />
      <div className="flex flex-1 min-h-0 min-w-0 w-full">
        <aside className="hidden lg:flex w-72 shrink-0 border-r bg-card/40 sticky top-14 h-[calc(100vh-3.5rem)]" data-testid="sidebar-docked">
          <FolderNav />
        </aside>
        <Sheet open={nav} onOpenChange={setNav}>
          <SheetContent side="left" className="w-80 p-0 lg:hidden" data-testid="sidebar-drawer">
            <SheetTitle className="sr-only">Folders</SheetTitle>
            <SheetDescription className="sr-only">Choose a folder</SheetDescription>
            <FolderNav onNavigate={() => setNav(false)} />
          </SheetContent>
        </Sheet>
        <main className="flex-1 min-w-0 max-w-full overflow-x-clip">{noteId ? <NoteEditor key={noteId} /> : view === "calendar" ? <CalendarView /> : <FolderView />}</main>
      </div>
      <footer className="border-t px-5 py-3 text-xs text-muted-foreground flex flex-wrap gap-x-4 gap-y-1 justify-between" data-testid="app-footer">
        <span className="flex items-center gap-1.5"><StarLogo className="h-3.5 w-3.5" /> StarVault • by Sammy Star</span>
        <span data-testid="footer-tagline">Private & Offline</span>
      </footer>
      <ProfileStudio open={dialog === "profile"} onOpenChange={close} />
      <MergeDialog open={dialog === "merge"} onOpenChange={close} />
      <BackupDialog open={dialog === "backup"} onOpenChange={close} />
      <AboutDialog open={dialog === "about"} onOpenChange={close} />
    </div>
  );
}
